import ColourConstants from "helpers/colourConstants";
import React from "react";
import { useTranslation } from "react-i18next";
import ActionButtonStyle from "styles/application/ActionButtonStyle";

// Init styled components
const AAD = ActionButtonStyle();

const ActionButtons = ({ handleAddDialogOpen }) => {
	const { t } = useTranslation();
	return (
		<AAD.ButtonContainer>
			<AAD.GeneralButton
				disableElevation
				variant="contained"
				onClick={handleAddDialogOpen}
				sx={{
					"&.MuiButton-root:hover": {
						backgroundColor: ColourConstants.deleteDialogHover,
						color: "#ffffff",
					},
				}}
			>
				{t("action.addNew")}
			</AAD.GeneralButton>
		</AAD.ButtonContainer>
	);
};

export default ActionButtons;
